import { Flex } from '@chakra-ui/react';
import SkeletonWrapper from '../../../../canopy-ui-components/components/Skeleton/SkeletonWrapper';
import { useCurrentColors } from '../../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import { useCheckForMobile } from '../../../../canopy-ui-components/hooks/UseResponsive/UseResponsive';
export default function ViewDocumentsSkeleton() {
    const isMobile = useCheckForMobile();
    const currentColors = useCurrentColors();
    return (
        <Flex
            backgroundColor={currentColors.componentBg}
            border={`1px solid ${currentColors.componentBorder}`}
            borderRadius={'4px'}
            padding={'12px'}
            direction="column"
            minHeight="100%"
            width="100%"
            maxHeight={isMobile ? 'unset' : 'full'}>
            <Flex justify="space-between">
                <Flex align="center">
                    <SkeletonWrapper
                        width="100px"
                        height="20px"
                    />
                </Flex>
                <Flex mr="15px">
                    <SkeletonWrapper
                        width="20px"
                        height="20px"
                    />
                </Flex>
            </Flex>

            <Flex
                min-height="calc(100% - 43px)"
                flexGrow={1}
                flexDirection={isMobile ? 'column' : 'row-reverse'}>
                <Flex
                    mt="20px"
                    paddingTop="4px"
                    flexDirection="column"
                    overflow="auto"
                    width={isMobile ? '100%' : '0'}
                    flexGrow={2}>
                    <Flex
                        padding="4px 0"
                        cursor={'pointer'}>
                        <Flex
                            align="flex-start"
                            width="100%">
                            <SkeletonWrapper
                                width="290px"
                                height="10px"
                            />
                            <Flex
                                flexGrow={1}
                                fontSize="13px"
                                fontWeight="medium"
                                alignItems="flex-start"
                                justifyContent="flex-end"
                                flexDirection="row"
                                width="calc(60% - 13px)"
                                textOverflow="ellipsis"
                                overflow="hidden"
                                whiteSpace="nowrap">
                                <Flex
                                    width="100%"
                                    flexDirection="column"
                                    alignItems="flex-end">
                                    <Flex justifyContent="flex-end">
                                        <SkeletonWrapper
                                            width="40px"
                                            height="10px"
                                        />
                                    </Flex>
                                    <Flex
                                        mt="10px"
                                        justifyContent="flex-end">
                                        <SkeletonWrapper
                                            width="40px"
                                            height="10px"
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>

                    {[1].map((_index) => (
                        <>
                            <Flex mt="10px">
                                <SkeletonWrapper
                                    width="100%"
                                    height="2px"
                                />
                            </Flex>
                            <Flex
                                mt="10px"
                                padding="4px 0"
                                cursor={'pointer'}>
                                <Flex
                                    align="flex-start"
                                    width="100%">
                                    <SkeletonWrapper
                                        width="290px"
                                        height="10px"
                                    />
                                    <Flex
                                        flexGrow={1}
                                        fontSize="13px"
                                        fontWeight="medium"
                                        alignItems="flex-start"
                                        justifyContent="flex-end"
                                        flexDirection="row"
                                        width="calc(60% - 13px)"
                                        textOverflow="ellipsis"
                                        overflow="hidden"
                                        whiteSpace="nowrap">
                                        <Flex
                                            width="100%"
                                            flexDirection="column"
                                            alignItems="flex-end">
                                            <Flex justifyContent="flex-end">
                                                <SkeletonWrapper
                                                    width="40px"
                                                    height="10px"
                                                />
                                            </Flex>
                                            <Flex
                                                mt="10px"
                                                justifyContent="flex-end">
                                                <SkeletonWrapper
                                                    width="40px"
                                                    height="10px"
                                                />
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </>
                    ))}
                </Flex>
            </Flex>
        </Flex>
    );
}
